// third party
import { combineReducers } from 'redux';

// project import
import customizationReducer from './customizationReducer';
import cameraReducer from './videoComponentReducer';

// ==============================|| REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  cameraReducer
});

export default reducer;
